import { render, staticRenderFns } from "./JobMainInfo.vue?vue&type=template&id=0878e9c8&scoped=true&"
import script from "./JobMainInfo.vue?vue&type=script&lang=ts&"
export * from "./JobMainInfo.vue?vue&type=script&lang=ts&"
import style0 from "./JobMainInfo.vue?vue&type=style&index=0&id=0878e9c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0878e9c8",
  null
  
)

export default component.exports